var __rspack_ns_object = JSON.parse('{"for investigational use only":"nur für Forschungszwecke","Confirm and hide":"Bestätigen und ausblenden"}')